import { PropsWithChildren, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFirebaseContext } from '../lib/context/Firebase.ts';
import { useAppSelector } from '../lib/hooks';
import { userHasRole } from '../lib/user-has-role.tsx';

interface ProtectedRouteProps extends PropsWithChildren {
    authenticated?: boolean | undefined
    roles?: string | [string] | undefined
}

export default function ProtectedRoute (props: ProtectedRouteProps) {
    const firebase = useFirebaseContext();
    const user = useAppSelector(state => state.user.user)
    const navigate = useNavigate();
    const location = useLocation();

    const allowed = !props.authenticated || (firebase.auth.currentUser != null && user != null && userHasRole(user, props.roles));

    useEffect(() => {
        if (!allowed) {
            if (user == null) {
                console.log("User is null, signing in again");
                navigate("/login?next=" + location.pathname)
            } else {
                console.log("User is present, but not allowed, redirecting to unauthorized screen");
                navigate("/errors/unauthorized?next=" + location.pathname)
            }
        }
    }, [user, allowed, navigate, location.pathname]);

    if (allowed) {
        return props.children
    } else {
        return (
            <div/>
        )
    }
}
